import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import * as moment from "moment";
import * as _ from 'lodash';

import {Data} from '../../providers/providers';
import {Thinning} from '../../providers/providers';
import {ThinningDataset} from "../../models/thinning-dataset";
import {AngularFirestoreCollection} from "angularfire2/firestore";


@Component({
    selector: 'page-thinning-measurement-export',
    templateUrl: 'thinning-measurement-export.html'
})
export class ThinningMeasurementExportPage {

    dataset: ThinningDataset;
    tsvForExport: string;

    constructor(public navCtrl: NavController,
                public viewCtrl: ViewController,
                navParams: NavParams,
                public data: Data,
                public thinning: Thinning) {
        this.dataset = navParams.get('dataset');
        this.buildTsv();
    }

    buildTsv() {
        let tsv = '';
        const measurements: AngularFirestoreCollection = this.data.getThinningMeasurementsCollection(this.dataset);

        measurements.valueChanges().subscribe((ms) => {
            //   // header row
            tsv += `Tree\tCluster\tFruitlet`;
            _.each(ms, (m) => {
                tsv += '\t' + moment(m.created).format('MM/DD/YYYY');
            });
            tsv += '\n';

            for (let t = 1; t <= this.dataset.tree_count; t++) {
                for (let c = 1; c <= this.dataset.cluster_count; c++) {
                    for (let f = 1; f <= this.dataset.flower_count; f++) {
                        tsv += `${t}\t${c}\t${f}`
                        _.each(ms, (m) => {
                            let val = m.data[`${t}_${c}_${f}`];
                            if (m.data_analysis[`${t}_${c}_${f}_outlier`]) {
                                val += '[O]'
                            }
                            if (m.data_analysis[`${t}_${c}_${f}_growth_rate_excessive`]) {
                                val += '[E]'
                            }
                            tsv += '\t' + (val ? val : '');
                        });
                        tsv += '\n';
                    }
                }
            }

            this.tsvForExport = tsv;
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/thinning-measurement-export/thinning-measurement-export.ts